import { Link } from "react-router-dom"
import getTableColumns from "../const/TABLE_COLUMNS"
import { Tooltip } from "antd"
import { EditFilled } from "@ant-design/icons"
import { Seller } from "../../../../domain/entities/Seller"
import { RoutePaths } from "../../../navigation/RoutePaths.enum"
import { observer } from "mobx-react"
import DataTable from "../../../components/DataTable/DataTable"
import { toJS } from "mobx"
import { useTranslation } from "react-i18next"
import { SellersViewModel } from "../SellersViewModel"
import { useContainerInjection } from "../../../hooks/useContainerInjection"
import DataTableRowsSkeleton from "../../../styledComponents/LoadingSkeletons/DataTableRowsSkeleton"

interface SellerTableProps {
	data: Partial<Seller>[]
	loading?: boolean
}

const SellerTable = ({ data, loading }: SellerTableProps) => {
	const viewModel = useContainerInjection<SellersViewModel>("SellersViewModel")
	const { t } = useTranslation("toolTips")

	const fiscalCountryOptions = Array.from(
		new Set(data.map(s => s.fiscalCountry).filter((c): c is string => !!c))
	).map(country => ({
		id: country,
		text: country,
		value: country
	}))

	return (
		<DataTable
			loading={loading}
			tableConfig={{
				sort: viewModel.tableConfig.sort,
				pageSize: viewModel.tableConfig.pageSize
			}}
			renderCustomLoadingComponent={() => <DataTableRowsSkeleton size="lg" />}
			onChange={data => {
				data.sorter &&
					viewModel.setTableConfig({ sort: { order: data.sorter.order, field: data.sorter.field } })
			}}
			onChangePage={(page, pageSize: number, lastPageFetched) => viewModel.setTableConfig({ pageSize })}
			columns={getTableColumns(data)}
			columnFilters={{
				fiscalCountry: fiscalCountryOptions
			}}
			dataSource={data.map((seller, idx) => ({
				key: seller.id,
				id: seller.id,
				userEmail: seller.userEmail,
				seller: seller.sellerName,
				contact: seller.contact,
				fiscalName: seller.fiscalName ?? "-",
				fiscalCountry: seller.fiscalCountry ?? "-",
				nif: seller.nif,
				iban: seller.iban,
				web: seller?.web ? (
					<a href={seller?.web} target="_blank">
						{seller?.web}
					</a>
				) : (
					"N/A"
				),
				editButton: (
					<div className="ant-employed">
						<Link to={RoutePaths.SELLERS_EDIT} state={{ seller: toJS(seller) }}>
							<Tooltip title={t("edit")}>
								<EditFilled />
							</Tooltip>
						</Link>
					</div>
				)
			}))}
		/>
	)
}

export default observer(SellerTable)
